import { FileLocation, FileOptionTabTitle } from "../types/fileUploadTypes";

export enum JobParameterName {
  FUNDS = "Fund",
  MANAGERS = "Manager",
}

export type JobType = FileOptionTabTitle;

export type JobParam = {
  parameterName: JobParameterName;
  value: string;
};

export type APIJobParam = {
  parameterName: string;
  value: string;
};

export type RunJobConfig = {
  location: FileLocation;
  params?: APIJobParam[];
};
